import { isTablet, isDesktop } from './MediaQueries.js'

export class MatchHeight {
  constructor (elem) {
    this.elem = elem
    this.matchHeightOn = this.elem.dataset.matchHeightOn
    this.items = this.elem.querySelectorAll('[data-match-height-item]')
    this.resizeTimeout = 0

    this.matchHeight()

    setTimeout(() => {
      this.matchHeight()
    }, 1000)

    window.addEventListener('resize', () => {
      clearTimeout(this.resizeTimeout)
      this.resizeTimeout = setTimeout(this.matchHeight.bind(this), 200)
    })
  }

  matchHeight () {
    this.items.forEach(item => {
      item.style.height = 'auto'
    })
    requestAnimationFrame(() => {
      if (this.shouldResize()) {
        const maxHeight = {}

        this.items.forEach(item => {
          const itemType = item.dataset.matchHeightItem
          const itemHeight = item.offsetHeight

          if (!maxHeight[itemType] || itemHeight > maxHeight[itemType]) {
            maxHeight[itemType] = itemHeight
          }
        })

        Object.keys(maxHeight).forEach(itemType => {
          const itemsOfType = this.elem.querySelectorAll(`[data-match-height-item="${itemType}"]`)
          itemsOfType.forEach(item => {
            item.style.height = `${maxHeight[itemType]}px`
          })
        })
      }
    })
  }

  shouldResize () {
    if (!this.matchHeightOn) {
      return true
    }

    let currentScreenSize
    if (isDesktop()) {
      currentScreenSize = 'desktop'
    } else if (isTablet()) {
      currentScreenSize = 'tablet'
    } else {
      currentScreenSize = 'mobile'
    }
    if (currentScreenSize === this.matchHeightOn) {
      return true
    }
    return false
  }
}

export function setupMatchHeight (parent) {
  const elems = parent.querySelectorAll('[data-match-height]')
  const items = []

  for (const element of elems) {
    items.push(new MatchHeight(element))
  }

  return items
}
